<!-- menu -->
<template>
  <div style="border: 0px solid red; height:100%">
    <el-dialog class="menu-dialog" :visible.sync="dialogTableVisible" :fullscreen="true">
      <el-tabs v-model="activeName" :stretch="true" @tab-click="tabsClick">
        <!-- タイムシート -->
        <el-tab-pane :label="$t('MODULE.MENU_LBL_TIMESHEET')" name="1" />
        <!-- 問合せ -->
        <el-tab-pane :label="$t('MODULE.MENU_LBL_TOIAWASE')" name="2" />
        <!-- スタッフ情報 -->
        <el-tab-pane :label="$t('MODULE.MENU_LBL_STAFFINFO')" name="3" />
      </el-tabs>
      <swiper class="menu-swiper" ref="mySwiper" @slidePrevTransitionEnd="slidePrevTransitionEnd()" @slideNextTransitionEnd="slideNextTransitionEnd()">
        <swiper-slide style="height:900px">
          <div class="home-menu">
            <!--  勤怠入力-->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:k0001}" @click="menuClick('k0001')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconqindai"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_KINTAI')}}</div>
            </el-button>

            <!-- 経費入力 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:k0006}" @click="menuClick('k0006')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconjingfei"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_KEIHI')}}</div>
            </el-button>

            <!-- スケジュール -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:s0001}" @click="menuClick('s0001')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconsch"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_SCHEDULE')}}</div>
            </el-button>

            <!-- 有給申請 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0015}" @click="menuClick('i0015')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconicon-test"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_PAIDAPPLY')}}</div>
            </el-button>

            <!--  お仕事案内 -->
            <el-button class="home-button" v-show style="margin-left:5px;margin-top:10px" :class="{}" @click="menuClick('i0017')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icongongzuo"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_WORKBAG')}}</div>
            </el-button>

            <!-- お仕事紹介 => ジョブ☆リターン-->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:immediate_payment}" @click="paymentJobClick('immediate_payment')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icongongzuo"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_JOB_INTRODUCTION')}}</div>
            </el-button>

            <!-- 即払い-->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:job_introduction}" @click="paymentJobClick('job_introduction')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconzhifu"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_IMMEDIATE_PAYMENT')}}</div>
            </el-button>
            <!-- 作業量一覧 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:w0001}" @click="menuClick('w0001')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconqiyue"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_AMOUNT')}}</div>
            </el-button>
          </div>
        </swiper-slide>
        <swiper-slide style="height:900px">
          <div class="home-menu1">
            <!-- 問合せ連絡先<br/>(オフィス事務センター) -->
            <el-button class="home-button" style="margin-top:10px;margin-left:38px" :class="{menuClick:btn1}" @click.native="btn1Click('btn1')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconoffice"></use>
              </svg><br />
              <div style="margin-top:-2px" v-html="$t('MODULE.K0005_LBL_BTN1')"></div>
            </el-button>

            <!-- ハラスメント相談窓口<br/>(社内相談フォーム) -->
            <el-button class="home-button" style="margin-top:10px;margin-left:5px" :class="{menuClick:btn2}" @click.native="btn2Click('btn2')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconform"></use>
              </svg><br />
              <div style="margin-top:-2px" v-html="$t('MODULE.K0005_LBL_BTN2')"></div>
            </el-button>

            <!-- ハラスメント相談窓口<br/>(社外メール相談) -->
            <!-- 0007936: 【AMS-BO】検証指摘No.1241　スタッフアプリ 問い合わせ>ハラスメント相談窓口（社外メール相談）のほうのみ非表示にしてください。(v-show="false") -->
            <el-button v-show="false" class="home-button" style="margin-top:10px;margin-left:38px" :class="{menuClick:btn3}" @click.native="btn3Click('btn3')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconyoujian"></use>
              </svg><br />
              <div style="margin-top:-2px" v-html="$t('MODULE.K0005_LBL_BTN3')"></div>
            </el-button>

            <!-- StaffExpressNEO<br/>ログイン -->
            <el-button v-show="false" class="home-button" style="margin-top:10px;margin-left:5px" :class="{menuClick:btn4}" @click.native="btn4Click('btn4')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconse_xitong"></use>
              </svg><br />
              <div style="margin-top:-2px" v-html="$t('MODULE.K0005_LBL_BTN4')"></div>
            </el-button>
          </div>
        </swiper-slide>
        　<swiper-slide style="height:900px">
          <div class="home-menu">
            <!-- スキル確認 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:k0003}" @click="menuClick('k0003')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#iconskill"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_HOURLYWAGE')}}</div>
            </el-button>

            <!-- 支給照会 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:p0001}" @click="menuClick('p0001')">
              <svg class="svg-icon" aria-hidden="true">
                <use xlink:href="#icongeiyu"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_PAY_INQUIRY')}}</div>
            </el-button>

            <!-- 契約照会  -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:c0001,bgColor:menuState.c0001Used==1}" @click="menuClick('c0001')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.c0001Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.c0001Used==2}">
                <use xlink:href="#iconqiyue"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_CONTRACT_INQUIRY')}}</div>
            </el-button>

            <!-- マイカー通勤 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:8px" :class="{menuClick:i0013,bgColor:menuState.i0008Used==1}" @click="menuClick('i0013')">
              <div class="iconfont iconjinggao menu-warn-icon-left" v-show="menuState.i0008Expired==0"></div>
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0008Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconLeftStyle:menuState.i0008Expired==0&&menuState.i0008Used!=2,iconRightStyle:menuState.i0008Expired!=0&&menuState.i0008Used==2}">
                <use xlink:href="#iconmycar"></use>
              </svg><br />
              <div style="margin-top:-6px;margin-bottom:-5px;" v-html="$t('MODULE.MENU_LBL_CAR_WORK')"></div>
            </el-button>

            <!-- スタッフ基本情報 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0001,bgColor:menuState.i0001Used==1}" @click="menuClick('i0001')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0001Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0001Used==2}">
                <use xlink:href="#iconjibenxinxi"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_BASIC_STAFF_INFO')}}</div>
            </el-button>

            <!-- 给与振込口座 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0003,bgColor:menuState.i0003Used==1}" @click="menuClick('i0003')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0003Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0003Used==2}">
                <use xlink:href="#iconhuikuan"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_SALARY_ACCOUNT')}}</div>
            </el-button>

            <!-- 緊急連絡先 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:8px" :class="{menuClick:i0004,bgColor:menuState.i0004Used==1}" @click="menuClick('i0004')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0004Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0004Used==2}">
                <use xlink:href="#iconjinjilianluo"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_EMERGENCY_CONTACT')}}</div>
            </el-button>

            <!-- 国籍確認 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0010,bgColor:menuState.i0010Used==1}" @click="menuClick('i0010')">
              <div class="iconfont  iconjinggao menu-warn-icon-left" v-show="menuState.i0010Expired==0"></div>
              <div class="iconfont  iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0010Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconLeftStyle:menuState.i0010Expired==0&&menuState.i0010Used!=2,iconRightStyle:menuState.i0010Expired!=0&&menuState.i0010Used==2}">
                <use xlink:href="#iconguoji"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_NATIONALITY_CONFIRM')}}</div>
            </el-button>

            <!-- マイナンバー -->
            <el-button class="home-button" style="margin-left:5px;margin-top:8px" :class="{menuClick:i0005,bgColor:menuState.i0005Used==1}" @click="menuClick('i0005OrI0006')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0005Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0005Used==2}">
                <use xlink:href="#iconshenfenzheng"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_MYNANBAR')}}</div>
            </el-button>

            <!-- 誓約·同意 -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0011,bgColor:menuState.i0011Used==1}" @click="menuClick('i0011')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0011Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0011Used==2}">
                <use xlink:href="#icontongyi"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_OATH_AGREE')}}</div>
            </el-button>

            <!-- 初期トレーニング -->
            <el-button class="home-button" style="margin-left:5px;margin-top:10px" :class="{menuClick:i0014,bgColor:menuState.i0014Used==1}" @click="menuClick('i0014')">
              <div class="iconfont iconshenqingzhong menu-warn-icon-right" v-show="menuState.i0014Used==2"></div>
              <svg class="svg-icon" aria-hidden="true" :class="{iconRightStyle:menuState.i0014Used==2}">
                <use xlink:href="#icondefault"></use>
              </svg><br />
              <div>{{$t('MODULE.MENU_LBL_TRAINING')}}</div>
            </el-button>
          </div>
        </swiper-slide>
      </swiper>
    </el-dialog>
    <!-- 导航栏 -->
    <el-header style="padding: 0px;width: 100%;height:100%;">
      <el-row class="home-logout-head">
        <!-- 菜单按钮 -->
        <span class="el-icon-menu css-white" @click="menuOpen" style="font-size: 32px;margin-top: 4px;padding-left: 4px;"></span>
        <!-- ajis-Logo -->
        <el-image style="margin-top: 6px;display:inline-block;vertical-align:top;" class="img-icon" :src="imgUrl1" alt />
        <!-- 导航右侧部分 -->
        <div class="menu-right" style="float:right">
          <!-- 通知图标 -->
          <el-badge class="badge-message" :hidden="mailNum==0" :value="mailNum">
            <i class="el-icon-message" @click="noticeClick()"></i>
          </el-badge>
          <!-- 用户头像 -->
          <div class="userhead">
            <el-image class="img-icon" :src="imgUrl2" alt />
          </div>
          <!-- 登录的用户名 -->
          <div class="username" :style="{fontSize:userFont}">
            <span>{{this.userInfo.userName}}</span>
          </div>
          <!-- 退出登录按钮 -->
          <div class="logoutIcn">
            <el-image @click="log_out" class="img-icon" :src="imgUrl3" alt />
          </div>
        </div>
      </el-row>
      <!--ヘッド--row-->
      <el-row class="home-tittle-head" align="left" style="padding-top:2px">
        <span class="css-white" style="font-size: 14px;padding-left:5px;text-align:left">{{this.homeTittle}}</span>
        <span v-html="hostName" style="font-size: 14px;float:right;color:white;margin-right:5px;"></span>
      </el-row>
      <el-row>
      </el-row>
    </el-header>
    <el-main style="padding: 0px 0px 0px 0px; width: 100%;height: 100%;">
      <router-view v-if="pageReload" />
    </el-main>
  </div>
</template>
<script>
import * as amsApi from "../api/home"
import b_0001 from "@/module/page/b_0001"
import store from '@/vuex/store'
let url = require("@/../config/sysConfig")
export default {
  name: "Map",
  components: {
    B0001: b_0001
  },
  data() {
    return {
      pageReload: true,
      userCd: '',
      s0001: false,
      c0001: false,
      p0001: false,
      d0001: false,
      i0001: false,
      i0002: false,
      i0003: false,
      i0004: false,
      i0005: false,
      i0007: false,
      i0008: false,
      i0010: false,
      i0011: false,
      i0013: false,
      i0014: false,
      i0015: false,
      i0016: false,
      k0001: false,
      k0003: false,
      k0006: false,
      btn1: false,
      btn2: false,
      btn3: false,
      btn4: false,
      paid: false,
      immediate_payment: false,
      job_introduction: false,
      w0001: false,
      activeName: '1',
      homeTittle: '',
      userInfo: [],
      menuState: {},
      drawer: false,
      dialogTableVisible: false,
      imgUrl1: require("@/statics/images/login.png"),
      imgUrl2: require("@/statics/images/account.png"),
      imgUrl3: require("@/statics/images/exit.png"),
      imgUrlaaa: require("@/statics/images/loginbac.png"),
      userFont: '1rem', //导航用户名字体大小（动态）
      hostName: '',
      menuOpenShow: false,//是否可以按下菜单按钮
    };
  },
  created() {
    // 导航用户名字体大小动态修改
    if (window.innerWidth < 360) {
      this.userFont = '.875rem'
    }
    this.homeTittle = this.$route.name
    //hostnameを取得
    this.hostName = store.state.hostname
  },
  //页面初期化
  mounted() {
    this.init_query();
  },
  methods: {
    // 初期化
    init_query() {
      amsApi.home().then(res => {
        this.userInfo = res.items.userInfo
        localStorage.setItem("userInfo", JSON.stringify(this.userInfo))
        this.userCd = this.userInfo.userCd
        if (!this.$route.params.pwResetForwardFlag) {
          this._pwFlagGet()
        } else {
          this.$router.push({ path: url.routerUrl_I0012 })
        }
      })
    },

    // パスワードフラグ検索
    _pwFlagGet() {
      amsApi.pwFlagGet(this.userCd).then(res => {
        var oneTimePwFlag = res.items.pwFlag[0].oneTimePwFlag
        this.$store.commit('passwordUpdate', oneTimePwFlag)
        if (oneTimePwFlag === '1') {
          // 初期パスワードを持ってログインユーザーと見做して、パスワード変更画面を表示する																						
          this.$router.replace({ path: url.routerUrl_I0012 })
        } else {
          // ワンタイムパスワードフラグが「0」の場合、
          this._menuStateManager()
        }
      })
    },

    // メニューボタンを押したら、各ボタンの状態を設定する
    menuOpen() {
      this.handleMenuData()
      //判断是否可以点击menu
      if (this.menuOpenShow) {
        amsApi.menuStateManager(this.userCd).then(res => {
          if (res.code == 204) {
            this.menuState = res.items.menuState[0]
            localStorage.setItem("menuState", JSON.stringify(this.menuState))
            //
            if (this.menuState.i0011Used == '0' && this.menuState.c0001Expired == '1') {
              this.menuOpenShow = false
            } else {
              this.menuOpenShow = true
            }
          }
        })
      }
      if (this.menuOpenShow) {
        return
      }
      //hostnameを取得
      this.hostName = store.state.hostname
      // Localhostから各ボタンの状態を取得する
      if (JSON.parse(localStorage.getItem('menuState'))) {
        this.menuState = JSON.parse(localStorage.getItem('menuState'))
        var that = this
        // 申請項目（プロフィール基本申請～契約照会）にはいずれか1または２であれば、ボタン情報を再取得
        var arr = []
        for (var key in this.menuState) {
          if (key.indexOf('Used') != -1) {
            // 获取所有申請項目状态
            arr.push(this.menuState[key])
          }
        }
        if (arr.indexOf(1) != -1 || arr.indexOf(2) != -1) {
          that._menuStateManager('menuOpen')
        } else {
          that.dialogTableVisible = true
        }
      } else {
        this._menuStateManager('menuOpen')
      }
    },

    // メニュー状態管理情報を取得する
    _menuStateManager(val) {
      amsApi.menuStateManager(this.userCd).then(res => {
        if (res.code == 204) {
          this.menuState = res.items.menuState[0]
          localStorage.setItem("menuState", JSON.stringify(this.menuState))
          if (val == 'menuOpen') {
            this.dialogTableVisible = true
          } else {
            this.mailSearch()
          }
          //判断是否可以点击menu
          if (this.menuState.i0011Used == '0' && this.menuState.c0001Expired == '1') {
            this.menuOpenShow = false
          } else {
            this.menuOpenShow = true
          }
        }
      })
    },

    //お知らせ検索
    mailSearch() {
      amsApi.noticeDetailGet(this.userCd).then(res => {
        if (res.code == '204') {
          this.tNoticeDetail = res.items.tNoticeDetail
          // 取未确认消息数量并更新入vuex
          var mailNum = 0
          for (var item of this.tNoticeDetail) {
            if (item.confirmFlag == '0') {
              mailNum++
            }
          }
          this.$store.commit('mailNum', mailNum)
        }
        this.pageJump(mailNum)
      })
    },

    //メニュー状態管理情報を取得する,画面を表示する
    pageJump(mailNum) {
      if (this.menuState.i0011Used == '1') {
        //誓約・同意は0の場合、誓約・同意画面を表示する
        this.$store.commit('increment', '1')
        this.menuOpenShow = true
        this.$router.push({ path: url.routerUrl_I0011 })
      } else if (this.menuState.c0001Used == '1') {
        //上記3.2.1で取得した契約照会は1の場合、契約照会画面を表示する
        this.$store.commit('increment', '1')
        this.menuOpenShow = true
        this.$router.push({ path: url.routerUrl_C0001 })
      } else if (this.menuState.i0008Expired == '0' && this.menuState.i0008Used != '2') {
        //上記3.2.1で取得したマイカー出勤申請(期間切れ) =「0」かつ　マイカー出勤申請) !=「2」の場合、マイカー出勤申請画面を表示する
        this.$store.commit('increment', '1')
        this.$router.push({ path: url.routerUrl_I0013 })
      } else if (mailNum > 0) {
        // 確認フラグは０の場合、お知らせ一覧画面を表示する
        this.$store.commit('increment', '1')
        this.$router.push({ path: url.routerUrl_B0001 })
      } else {
        this.$router.push({ path: url.routerUrl_S0001 })
      }
    },

    //menu选中
    menuClick(path) {
      // 修改被选中的menu边框样式
      this.menuSelected(path)
      if (path == 'i0005OrI0006') {
        if (this.menuState.i0005Used == '1') {
          path = 'i0005'
        } else {
          path = 'i0006'
        }
      }

      //有給申請
      if (path == 'paid') {
        window.open(url.routerUrl_paid_apply)
        return
      }

      if ('/' + path != this.$route.path) {
        //画面遷移
        this.$router.push({ path: path })
      }

      // 关闭menu
      this.dialogTableVisible = false
    },

    // 修改被选中的menu边框样式
    menuSelected(val) {
      this.s0001 = false
      this.c0001 = false
      this.p0001 = false
      this.d0001 = false
      this.i0001 = false
      this.i0002 = false
      this.i0003 = false
      this.i0004 = false
      this.i0005 = false
      this.i0007 = false
      this.i0008 = false
      this.i0010 = false
      this.i0011 = false
      this.i0013 = false
      this.i0014 = false
      this.i0015 = false
      this.i0016 = false
      this.k0001 = false
      this.k0003 = false
      this.k0006 = false
      this.btn1 = false
      this.btn2 = false
      this.btn3 = false
      this.btn4 = false
      this.paid = false
      this.immediate_payment = false
      this.job_introduction = false
      this.w0001 = false
      this[val] = true
    },

    // 問合せ連絡先<br/>(オフィス事務センター)
    btn1Click(val) {
      var vm = this;
      this.menuSelected(val)
      localStorage.setItem(url.routerUrl_K0008, JSON.stringify(true))
      vm.$router.push({ path: url.routerUrl_K0008 })
      this.dialogTableVisible = false
    },
    //add by hexy 20210105 start
    // ハラスメント相談窓口<br/>(社内相談フォーム)
    btn2Click(val) {
      this.menuSelected(val)
      window.open(url.routerUrl_K0005_btn3URL)
    },

    // ハラスメント相談窓口<br/>(社外メール相談
    btn3Click(val) {
      this.menuSelected(val)
      window.open("mailto: info1-ajis-group@solare-sr.com")
    },

    // StaffExpressNEO<br/>ログイン
    btn4Click(val) {
      this.menuSelected(val)
      window.open(url.routerUrl_K0005_btn1URL)
    },

    //お仕事紹介,即払い
    paymentJobClick(val) {
      var token = $cookies.get('token');
      this.menuSelected(val);

      //お仕事紹介
      if (val == 'immediate_payment') {
        window.open(url.routerUrl_immediate_payment + '?Authorization=' + token, '_top');
        return;
      };

      //即払い
      if (val == 'job_introduction') {
        window.open(url.routerUrl_job_introduction + '?Authorization=' + token, '_top');
        return;
      };

    },

    // 点击tabs时，menu切换
    tabsClick() {
      var index = Number(this.activeName) - 1
      this.swiper.slideTo(index, 200, false)
    },

    // 右滑
    slideNextTransitionEnd() {
      this.activeName = Number(this.activeName) + 1 > 3 ? '3' : (Number(this.activeName) + 1).toString()
    },
    // 左滑
    slidePrevTransitionEnd() {
      this.activeName = Number(this.activeName) - 1 < 1 ? '1' : (Number(this.activeName) - 1).toString()
    },

    // 点击お知らせicon
    noticeClick() {
      this.handleMenuData()
      if (this.menuOpenShow) {
        return
      }
      this.pageReload = false
      // 重新加载页面（不是刷新）
      this.$nextTick(function () {
        this.pageReload = true
      })
      this.$router.push({ path: url.routerUrl_B0001 })
    },

    // ログアウト処理
    log_out() {
      this.$message.closeAll()
      var vm = this
      // vuex重置
      this.$store.commit('increment', '0')
      this.$store.commit('passwordUpdate', '0')
      this.$store.commit('mailNum', 0)
      vm.$router.push({ path: "/login" })
    },
    //路由变化 menu缓存数据获取
    handleMenuData() {
      this.menuState = JSON.parse(localStorage.getItem('menuState'))
      if (this.menuState.i0011Used == '0' && this.menuState.c0001Expired == '1') {
        this.menuOpenShow = false
      } else {
        this.menuOpenShow = true
      }
    },
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    },

    //监听「ワンタイムパスワードフラグ」变化
    oneTimePwFlag() {
      return this.$store.state.oneTimePwFlag
    },

    // 监听vuex中mailNum变化
    mailNum() {
      return this.$store.state.mailNum
    }
  },
  watch: {
    $route: {
      handler(to, from) {
        this.homeTittle = this.$route.name
      },
    },
    // 监听oneTimePwFlag状态变化
    oneTimePwFlag(val) {
      if (val == '0') {
        this._menuStateManager()
      }
    }
  }
};
</script>
<style>
.el-header * {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
/*导航logo*/
.img-icon {
  outline: 0 none !important;
}
.el-drawer.ltr {
  height: 100% !important;
}
.el-dialog__wrapper {
  height: 500% !important;
}
.el-menu-item.is-active {
  background-image: linear-gradient(#3cc6fa, #1197ca);
}

.el-menu-item {
  border-top: 1px solid #fff;
  font-size: 14px;
}
.el-menu {
  border: none;
  border-bottom: 1px solid #fff;
}
.clsDrawerBody {
  color: #ffffff;
  font-size: 15px;
  padding-left: 8px;
}

.el-main {
  height: 100%;
  padding: 0 !important;
  overflow: hidden;
  position: relative;
}

.el-drawer {
  background-image: url('~@/statics/images/loginbac111.png');
  border-bottom-right-radius: 3px;
  border-top-right-radius: 3px;
}

.menu-swiper {
  transform: translate3d(0, 0, 0);
  overflow: hidden;
}

/*drawerのopen style*/
.v-modal {
  background-color: transparent;
}

/*ログオフヘード // background-color: #565858;*/
.home-logout-head {
  padding-left: 0;
  height: 40px;
  background-color: #23b2e8;
  color: '#ffffff';
  width: 100%;
}
.home-tittle-head {
  padding-left: 0;
  height: 25px;
  background-image: linear-gradient(#5c5d5d, #717171);
  color: '#ffffff';
  width: 100%;
}
/* 
 *menu-header
 *menu按钮
 */
.menu-header {
  height: 50px;
}

/* menu右侧用户信息部分 */
.menu-right {
  width: calc(100vw - 10.625rem);
  display: -webkit-flex;
  display: flex;
  -webkit-justify-content: flex-end;
  justify-content: flex-end;
  align-items: center;
  height: 40px;
  padding-right: 3px;
  min-width: 160px;
}

/* 用户名 */
.username {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #ffffff;
  display: inline-block;
  vertical-align: top;
}

/* 通知图标 */
.badge-message {
  color: #fff;
  font-size: 1.4375rem;
  margin-right: 0.2rem;
}
.badge-message .el-badge__content {
  padding: 4px;
  font-size: 8px;
  height: 5px;
  top: 5px;
  line-height: 0.6;
}

/* 用户头像 */
.userhead {
  margin: 0px 0.1875rem 0px 0.1875rem;
  color: #ffffff;
  min-width: 25px;
}

/* 退出登录按钮 */
.logoutIcn {
  margin: 0px 0.1875rem 0px 0.1875rem;
  color: #ffffff;
  min-width: 25px;
}

.home-menu {
  width: 90%;
  margin: 0 auto;
  transform: translate3d(0, 0, 0);
}
.home-button.el-button {
  width: 30%;
  font-size: 11px;
  padding: 8px 0px 8px 0px;
  background-image: linear-gradient(#fcfcfc, #ececea);
}

.bgColor.el-button {
  border: none;
  background-image: linear-gradient(#f1b48c) !important;
}

.home-menu1 {
  width: 100%;
  margin: 0 auto;
  transform: translate3d(0, 0, 0);
}
.el-button + .el-button {
  margin: 0px;
}
.home-menu1 .el-button {
  width: 38%;
  font-size: 11px;
  padding: 8px 0px 5px 0px;
  background-image: linear-gradient(#fcfcfc, #ececea);
}
/* menu弹框 */
.menu-dialog .el-dialog__header {
  /* display: none !important; */
  padding: 20px;
}
.menu-dialog .el-dialog.is-fullscreen {
  background-color: rgba(117, 117, 117, 0.8);
}
/* 关闭按钮 */
.menu-dialog .el-dialog__headerbtn .el-dialog__close {
  font-size: 16px;
  top: -10px;
  right: -10px;
  position: relative;
  color: #fff;
}
.menu-dialog .el-icon-close:before {
  font-size: 25px;
}

/* menu按钮图标样式 */
.menu-icon {
  font-size: 32px;
  /* margin-top: 4px; */
  padding-left: 14px;
  margin-right: 14px;
  /* color: #3cc6fa; */
}

/*  
    登録が終了していない項目があれば
    その項目左上に⚠を出したい
 */
.menu-warn-icon-left {
  color: red;
  font-size: 16px;
  float: left;
  position: relative;
  left: 5px;
}
.menu-warn-icon-right {
  color: red;
  font-size: 16px;
  float: right;
  position: relative;
  right: 5px;
}
.icon-shijian:before {
  /* margin-left: -15px; */
  position: relative;
  left: 0px;
}

.menu-dialog .el-dialog__body {
  padding: 0;
  padding-top: 8px;
  margin: 0 8px 0 8px;
}

.menu-dialog .el-tabs__item {
  color: #fff;
  padding: 0;
  font-size: 16px;
  border: none;
  box-shadow: none;
}
.menu-dialog .el-tabs__item.is-active {
  color: #00bfff;
}
.menu-dialog .el-tabs__active-bar {
  background-color: #00bfff;
}
/* 选中的menu边框高亮 */
.menuClick {
  border: 3px solid #00bfff !important;
}

.svg-icon {
  width: 3em;
  height: 3em;
  vertical-align: 6px;
  fill: currentColor;
  overflow: hidden;
}

.iconLeftStyle {
  margin-left: -15px;
}

.iconRightStyle {
  margin-right: -15px;
}
</style>


// WEBPACK FOOTER //
// src/components/page/home.vue